import React from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import { useEffect, useState, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
//import { BackToKdealerLogin, LogoutDealer, LoginDealer } from '../GlobalScript'
import Table from 'react-bootstrap/Table';
import Cookies from 'js-cookie';
import { GetDomain, RemoveCookie, GetCoockie, days, user_session_id, shopping_cart_session_days, shopping_cart_session_id, IsKDealerWebsite, IskCountryWebsite, IsLocalHost, GetRedirectHost, generateSixDigitNumber, UpdateShoppingCart, GetRedirectURL } from "../GlobalScript";
import { ShoppingCartContext } from './ShoppingCartContext';
export default function SSO() {
    const navigate = useNavigate();
    const [UserInfo, setUserInfo] = useState(null);
    const [Loading, setLoading] = useState(true);
    //const days = 8/24;
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const LoginUser = async (id, addtoCart) => {
        try {
            let usrSession;

            if (addtoCart === true) {
                const response = await fetch("kdealer/GetPunchoutOrder/" + id);

                if (response.status !== 200) {
                    throw new Error("Invlaid user!");
                }
                usrSession = await response.json();
            }
            else {
                const response = await fetch("kdealer/ValidateUser/" + id);

                if (response.status !== 200) {
                    throw new Error("Invlaid user!");
                }
                usrSession = await response.json();

            }

            const userObj = {
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'dealerName': usrSession.dealerName,
                'dealerID': usrSession.dealerID,
                'loginType': usrSession.loginType,
                'region': usrSession.region,
                'address': usrSession.address,
                'isAdmin': usrSession.isAdmin,
                'loading': 0,
                'buyerCookie': usrSession.buyerCookie
            };

            let domain = GetDomain();
            console.log('domain: ' + domain);

            if (domain === '') {
                Cookies.set('user', JSON.stringify(userObj), { expires: days });
            } else {
                Cookies.set('user', JSON.stringify(userObj), { expires: days, domain: domain, secure: true });
            }
            //Cookies.set('user', userObj, { expires: 8/24 });
            //setUserInfo(userObj);
            setUserInfo({
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'loginType': usrSession.loginType,
                'kmcst': usrSession.KMCST,
                'dealerID': usrSession.dealerID,
                'rdmString': id,
                'isAdmin': usrSession.isAdmin,
                "buyercookie": usrSession.buyerCookie,
            });

            localStorage.removeItem('shoppingcart');
            localStorage.removeItem("orderSearch");
            localStorage.removeItem("creditSearch");

            window.GlobalLoading = 0;
            console.log('cookie: ' + GetCoockie());
            //window.location.href = '/dealerhome';

            if (addtoCart === true) {
                handleAddToCart(usrSession.items);
                if (IsKDealerWebsite || IsLocalHost) {
                    navigate('/neworder');
                } else {
                    LogoutDealerClick();
                }
            }
            else {
                const url = GetRedirectURL(usrSession.redirectType);
                if (usrSession.loginType === 1) {
                    if (IsKDealerWebsite || IsLocalHost) {
                        if (usrSession.redirectType > 1) {
                            if (usrSession.redirectType >= 10 || usrSession.redirectType === 3) {
                                NavigateToCatalog(usrSession.redirectType, true);
                            }
                            else {
                                navigate(url);
                            }
                        }
                        else {
                            navigate('/dealerhome');
                        }
                    } else {
                        LogoutDealerClick();
                    }
                } else if (usrSession.loginType === 5) {
                    if (IskCountryWebsite || IsLocalHost) {
                        if (usrSession.redirectType > 1) {
                            if (usrSession.redirectType >= 10 || usrSession.redirectType === 3) {
                                NavigateToCatalog(usrSession.redirectType, false);
                            }
                            else {
                                navigate(url);
                            }
                        }
                        else {
                            navigate('/kcountrieshome');
                        }
                    } else {
                        LogoutDealerClick();
                    }
                } else {
                    navigate('/login');
                }
            }

        } catch (e) {
            //window.location.href = '/login';
            navigate('/login');
        }
    }
    const NavigateToCatalog = (id, isDealer) => {
        if (id === 3) {
            const url = isDealer === true ? "/dealerhome" :"/kcountrieshome";
            navigate(url, { state: { inquiry:1 } });
        }
        else if (id === 10) {
            navigate('/catalog', { state: { level1: '3', level2: null, level1Name: "Clothing", level2Name: null, level3: null, level3name: null, keywords: null } });
        }
        else if (id === 11) {
            navigate('/catalog', { state: { level1: '6', level2: null, level1Name: "Order Catalogs", level2Name: null, level3: "56", level3name: "Accessory Catalogs", keywords: null } });
        }
        else if (id === 12) {
            navigate('/catalog', { state: { level1: '34', level2: null, level1Name: "Accessory Packages", level2Name: null, level3: null, level3name: null, keywords: null } });
        }
        else if (id === 13) {
            navigate('/catalog', { state: { level1: '34', level2: null, level1Name: "Accessory Packages", level2Name: null, level3: "215", level3name: "Side x Side Packages", keywords: null } });
        }
        else if (id === 14) {
            navigate('/catalog', { state: { level1: '34', level2: null, level1Name: "Accessory Packages", level2Name: null, level3: "134", level3name: "NAV® 4e Packages", keywords: null } });
        }
        else if (id === 15) {
            navigate('/catalog', { state: { level1: '34', level2: null, level1Name: "Accessory Packages", level2Name: null, level3: "153", level3name: "RIDGE® Packages", keywords: null } });
        }
        else if (id === 16) {
            navigate('/catalog', { state: { level1: '34', level2: null, level1Name: "Accessory Packages", level2Name: null, level3: "107", level3name: "Teryx® Packages", keywords: null } });
        }
        else if (id === 17) {
            navigate('/catalog', { state: { level1: '23', level2: null, level1Name: "Essentials", level2Name: null, level3: "208", level3name: "Oil Change Kits", keywords: null } });
        }
       
       
       
    }
    const handleAddToCart = async (items) => {
        try {
            //handlePop();
            //CheckSession();
            const user = GetCoockie();
            if (!items || items.length === 0) {
                return;
            }
            let orderType = "1";
            let dealerID = user.dealerID;
            let kCode = '';
            const arr = [];
            items.forEach((itm) => {
                //const skuqty = {
                //    label: user.dealerID,
                //    value: itm.sku,
                //};
                //const rqst = {
                //    method: 'POST',
                //    headers: {
                //        'Content-type': 'application/json'
                //    },
                //    body: JSON.stringify(skuqty)
                //};
                //const res = await fetch('kdealer/GetSKUImage/', rqst);
                //if (res.status !== 200) {
                //    throw new Error(res.statusText);
                //}
                //const img = await res.text();

                const item = {
                    "item":
                    {
                        "itemStaCode": "1",
                        "distitemNbr": itm.sku,
                        "warehouseAvailColorR": "G0000002",
                        "warehouseAvailColorD": "G0000002",
                        "warehouseAvailColorL": "G0000002",
                        "dealerPrice": 0,
                        "retailPrice": 0,
                        "whslePkgCnt": 1,
                        "prodOrdCnt": itm.qty,
                        "boCnt": 0,
                        "qty": itm.qty,
                        "qtyOrdered": itm.qty,
                        "factorAlert": false,
                        "errorMsg": "",
                        "inventoryType": "",
                        "inventoryTypeIcon": "",
                        "statusIcon": "",
                        "hazMatCode": "N",
                        "oversizeCode": "N",
                        "substitutedSKU": "",
                        "ltl": false,
                        "pk": false,
                        "memo": itm.memo,
                        "new": true
                    },
                    "addInfo": {
                        "itemStaCode": "1",
                        "itemStaIcon": "green-icon",
                        "itemNumber": itm.sku,
                        "itemStaText": null,
                        "itemDesc": "",
                        "prodLinesText": "",
                        "yearString": "",
                        "eligibleExchangeReturn": "",
                        "dimentions": "",
                        "weightVal": "",
                        "img": '',
                        "returnable": false,
                        "exchangable": false
                    }
                }
                arr.push(item);
            });



            const combinedCart = {
                alerts: null,
                items: arr,
                orderName: generateSixDigitNumber(),
                orderType: orderType,
                shipToDealerID: dealerID,
                kCode: kCode,
                fromVIPortal: true
            }
            UpdateShoppingCart(combinedCart, setShoppingCart);
        } catch (e) {
            console.log(e);
        } finally {

        }
    }
    //const GetCart = async (cartid)=>{
    //    const response = await fetch("kdealer/GetPunchoutOrder/" + cartid);

    //    if (response.status !== 200) {
    //        throw new Error("Invlaid user!");
    //    }
    //    const usrSession = await response.json();

    //}
    useEffect(() => {
        if (Loading) {
            const queryParameters = new URLSearchParams(window.location.search);
            const id = queryParameters.get("id");
            if (!id) {
                const cartid = queryParameters.get("cartid");
                if (cartid && cartid !== '') {
                    LoginUser(cartid, true);
                }
                else {
                    navigate('/login');
                }
            }
            else {
                LoginUser(id, false);
            }
            setLoading(false);
        }
    }, [Loading])

    const LogoutDealerClick = () => {
        debugger;
        let domain = GetDomain();
        if (domain === '') {
            Cookies.set('redirect', "1", { expires: days });
        } else {
            Cookies.set('redirect', "1", { expires: days, domain: domain, secure: true });
        }
        RemoveCookie(days, user_session_id);
        window.location.replace(GetRedirectHost + '/login');
        console.log(GetRedirectHost + '/login');
        setUserInfo(null);
    }

    return (
        <>
            <Container className="checkout-container main-container">
                <Row className="order-table order-page">
                    {/*<Col className="hr-left checkout-title-under">Information Provided*/}
                    {/*</Col>*/}

                    {UserInfo ?
                        <>
                        </> :
                        <>
                            <Col>
                                Logging in...
                            </Col>
                        </>
                    }
                </Row>
            </Container>
        </>
    );
}